var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNftLoading3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 306,
    viewBox: "0 0 480 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10139_54084)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 22,
    transform: "translate(20 15)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 54,
    width: 480,
    height: 44,
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 14,
    transform: "translate(20 69)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 14,
    transform: "translate(160 69)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 14,
    transform: "translate(380 69)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 480,
    height: 52,
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 22,
    transform: "translate(20 113)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 22,
    transform: "translate(160 113)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 22,
    transform: "translate(380 113)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 150,
    width: 480,
    height: 52,
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 22,
    transform: "translate(20 165)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 22,
    transform: "translate(160 165)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 22,
    transform: "translate(380 165)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 480,
    height: 52,
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 22,
    transform: "translate(20 217)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 22,
    transform: "translate(160 217)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 22,
    transform: "translate(380 217)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 254,
    width: 480,
    height: 52,
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 22,
    transform: "translate(20 269)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 22,
    transform: "translate(160 269)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 22,
    transform: "translate(380 269)",
    fill: "#1A1A1A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 479,
    height: 305,
    rx: 4.5,
    stroke: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10139_54084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 306,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNftLoading3);
export default __webpack_public_path__ + "static/media/icon-nft-loading-3.419eb9b7c048639d7a252a1f682c3b28.svg";
export { ForwardRef as ReactComponent };